/* eslint-disable func-names */
import * as Yup from 'yup';

const requiredMsg = 'This field is required!';

export const SummarySchema = Yup.object().shape({
  title: Yup.string().required(requiredMsg),
  clinicalNotes: Yup.string().required(requiredMsg).nullable(),
  plan: Yup.string().required(requiredMsg),
  summary: Yup.string().required(requiredMsg),
  note: Yup.string().nullable(),
  followUpDate: Yup.date().nullable(),
});

export const AdminFeeSchema = (minFee, currency = 'SGD') =>
  Yup.object().shape(
    {
      admin: Yup.bool().required(requiredMsg),
      adminFee: Yup.number()
        .transform(value => (value === '' ? undefined : +value))
        .when('admin', {
          is: true,
          then: Yup.number().min(
            minFee,
            `The fee must be greater than or equal to ${minFee} ${currency}`,
          ),
          otherwise: Yup.number().min(0),
        })
        .required(requiredMsg),
    },
    [['admin', 'adminFee']],
  );
